
<div class="row">
    <div class="col-12">

        <div class="filter">

            <!-- header -->
            <div class="filter-header">

                <!-- title -->
                <div class="header">
                    <h4> Фильтр </h4>
                </div>

                <!-- btn close window -->
                <div class="btn-close">
                    <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                        <span aria-hidden="true">&times;</span>
                    </button> -->
                    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                    </button>
                </div>

            </div>

            <!-- filter form -->
            <div class="filter-form">

                <form class="form" [formGroup]="filterForm" autocomplete="off">

                    <div class="row">

                        <!-- atribut -->
                        <div class="col-6 input">
                            <div class="form-group">
                                <label for="atribut" class="label"> АТРИБУТ </label>
                                <input type="text" class="form-control" placeholder="Введите значение" id="atribut" formControlName="atribut">
                            </div>
                        </div>

                        <!-- atribute_type -->
                        <div class="col-6 input">
                            <div class="form-group" class="label">
                                <label for="atribute_type"> ТИП АТРИБУТА </label>
                                <ng-select  
                                    class="custom"
                                    placeholder="Выберите значение" 
                                    clearAllText="{{ 'CLEAN' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindLabel="value"
                                    bindValue="key"
                                    formControlName="atribute_type"
                                    [loading]="loading"
                                    [items]="atributeTypes">
                                </ng-select>
                            </div>
                        </div>

                        <!-- author -->
                        <div class="col-6 input">
                            <div class="form-group">
                                <label for="author" class="label"> АВТОР </label>
                                <ng-select  
                                    class="custom"
                                    placeholder="Выберите значение" 
                                    clearAllText="{{ 'CLEAN' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindLabel="name"
                                    bindValue="id"
                                    formControlName="author"
                                    [loading]="loading"
                                    [items]="getAuthor">
                                </ng-select>
                                <!-- <input type="text" class="form-control" placeholder="Введите значение" id="author" formControlName="author"> -->
                            </div>
                        </div>

                        <!-- complete_scale -->
                        <div class="col-6 input">
                            <div class="form-group" class="label">
                                <label for="complete_scale"> ШКАЛА ЗАПОЛНЕННОСТИ </label>
                                <ng-select  
                                    class="custom"
                                    placeholder="Выберите значение" 
                                    clearAllText="{{ 'CLEAN' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindLabel="value"
                                    bindValue="key"
                                    formControlName="complete_scale"
                                    [loading]="loading"
                                    [items]="occupancyScale">
                                </ng-select>
                            </div>
                        </div>

                        <!-- group -->
                        <div class="col-6 input">
                            <div class="form-group" class="label">
                                <label for="group"> ГРУППА </label>
                                <ng-select  
                                    class="custom"
                                    placeholder="Выберите значение" 
                                    clearAllText="{{ 'CLEAN' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindLabel="name"
                                    bindValue="id"
                                    formControlName="group"
                                    [loading]="loading"
                                    [items]="attributeGroups">
                                </ng-select>
                            </div>
                        </div>

                        <!-- type -->
                        <div class="col-6 input">
                            <div class="form-group" class="label">
                                <label for="type"> ТИП </label>
                                <ng-select  
                                    class="custom"
                                    placeholder="Выберите значение" 
                                    clearAllText="{{ 'CLEAN' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindLabel="translate"
                                    bindValue="id"
                                    formControlName="type"
                                    [loading]="loading"
                                    [items]="attributeValueTypes">
                                </ng-select>
                            </div>
                        </div>

                        <!-- format -->
                        <div class="col-6 input">
                            <div class="form-group" class="label">
                                <label for="format"> ФОРМАТ </label>
                                <ng-select  
                                    class="custom"
                                    placeholder="Выберите значение" 
                                    clearAllText="{{ 'CLEAN' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindLabel="translate"
                                    bindValue="id"
                                    formControlName="format"
                                    [loading]="loading"
                                    [items]="attributePresentationTypes">
                                    <ng-template ng-option-tmp let-item="item">
                                        <div title="{{ item.translate }}"> {{ item.translate }} </div>
                                    </ng-template>
                                </ng-select>
                            </div>
                        </div>

                        <!-- obligation -->
                        <div class="col-6 input">
                            <div class="form-group" class="label">
                                <label for="obligation"> ОБЯЗАТЕЛЬНОСТЬ </label>
                                <ng-select  
                                    class="custom"
                                    placeholder="Выберите значение" 
                                    clearAllText="{{ 'CLEAN' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    bindLabel="value"
                                    bindValue="key"
                                    formControlName="obligation"
                                    [loading]="loading"
                                    [items]="obligations">
                                </ng-select>
                            </div>
                        </div>
                    </div>

                </form>

            </div>

        </div>

    </div>
</div>

    <hr>

<div class="row">
    <div class="col-12">

        <!-- buttons -->
        <div class="buttons">

            <!--  -->
            <button type="button" class="btn btn-light btn-back reset" (click)="resetFilterForm()">
                Сбросить
            </button>

            <!--  -->
            <button type="button" class="btn btn-primary btn-create" (click)="send()">
                Применить
            </button>

        </div>

    </div>
</div>